import svg1 from "../../images/png_abt.png";
import svg2 from "../../images/svg_4.svg";
import svg3 from "../../images/svg_5.svg";
import svg4 from "../../images/svg_6.svg";
import svg5 from "../../images/svg_7.svg";
import svg6 from "../../images/svg_9.svg";
import svg7 from "../../images/svg_10.svg";
import svg8 from "../../images/svg_11.svg";
import svg9 from "../../images/svg_12.svg";
import svg10 from "../../images/svg_13.svg";
import collart from "../../images/collart.svg";
import svg11 from "../../images/arkZephyr.svg";
import svg14 from "../../images/svg_14.svg";

export const HomeObjIntro = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "About",
  headline: "I build things!",
  description:
    "Hi, I am a Web Developer, but I can just about help you with anything! Even if all you have is an idea, we can connect your vision and my execution to give it life! \n\nGet market ready solutions for all your problems!",
  buttonLabel: "Collaborate",
  imgStart: true,
  img: svg7,
  alt: "e-com",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://github.com/AlistairHeus/",
};

export const HomeObjAbout = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Web Developer",
  headline: "Curious?",
  description:
    "Discover my talents through the projects that I've spent most of my time on! \n\n",
  buttonLabel: "See my work!",
  imgStart: false,
  img: svg9,
  alt: "chat",
  dark: true,
  primary: true,
  darkText: false,
  to: "zephyris",
};

export const HomeObjMERN = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "Full Stack M.E.R.N Blog",
  description:
    "The main objective of building this project was to test my understanding of Node.JS, Express.JS and MongoDb working together along with React. This project was built to showcase the applications of CRUD operations. I developed a REST api which handled user authentication, posts, and updating user credentials.",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg2,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://mern-blog-client.web.app/",
};

export const HomeObjNode = {
  id: "zephyris",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "Node-Zephyr: Chat and Collaborate!",
  description:
    "The Chat application uses firebase for hosting, authentication and Firestore real-time Database for handling real time messaging. Client side developed using React JS library. ",
  buttonLabel: "Visit",
  imgStart: false,
  img: svg3,
  alt: "chat",
  dark: true,
  primary: true,
  darkText: false,
  href: "https://zephyris-20616.web.app/",
};

export const HomeObjMeraki = {
  id: "meraki",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "Meraki Gallery: E-Commerce Website",
  description:
    "Meraki Art Gallery was built with a clean and minimalistic UI for a satisfying user experience. \n\nMet with the client's vision for the website after understanding their products and services range. Integrated secure payment and shipping gateways in the website. Developed online marketing and promotional solutions and monitored webstite traffic to generate reports.",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg4,
  alt: "e-com",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://merakiartgallery.com/",
};

export const HomeObjCollart = {
  id: "collart",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "House of Collart",
  description:
    "House of Collart is an e-commerce store built with user experience in mind and was made with payment gateways and a secure implementation along with the necessary security certificates. ",
  buttonLabel: "Go to in-development website!",
  imgStart: true,
  img: collart,
  alt: "e-com",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://houseofcollart.com/",
};

export const HomeObjContact = {
  id: "contact",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Contact Me!",
  headline: "Kartik Jha",
  description:
    "+91 8605640371 \n \nkartikjha13@gmail.com  \n \n@lazyilliteratebernard",
  buttonLabel: "Contact me!",
  imgStart: false,
  dark: true,
  img: svg6,
  primary: true,
  darkText: false,
  href: "https://mail.google.com/mail/?view=cm&fs=1&to=kartikjha13@gmail.com&&body=Hey Kartik",
};

export const HomeObjCrypto = {
  id: "crypto",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Other Projects",
  headline: "Crypto Tracker",
  description:
    "Used CoinGecko api for tracking the prices of Crypto Currencies and React for the Front-End ",
  buttonLabel: "Visit",
  imgStart: false,
  img: svg5,
  alt: "cryp",
  dark: true,
  primary: true,
  darkText: false,
  href: "https://crypto-tracker-app-26c57.web.app/",
};

export const HomeObjBlog = {
  id: "blog",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Featured Blogs",
  headline: "My Full Stack Web Dev Journey",
  description:
    "How I approached Web Development and learning all of the requisite technologies and best practices and summary of the said technologies and why they are ruling the industry",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg8,
  alt: "e-com",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://mern-blog-client.web.app/post/6114ef482a2a5500e46b9dfc",
};

export const HomeObjMusic = {
  id: "music",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Other Projects",
  headline: "My Custom Music Player",
  description:
    "I am a musician, a producer, and someone who is keenly interested in the engineering aspects of making music. I also wanted a place to display my own music, why not make my own web music player then? ",
  buttonLabel: "Visit",
  imgStart: false,
  img: svg10,
  alt: "cryp",
  dark: true,
  primary: true,
  darkText: false,
  href: "https://zephyris-portfolio-w-app.web.app/music",
};

export const HomeObjArk = {
  id: "arkzephyr",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Other Projects",
  headline: "Plot Organizer",
  description:
    "A hobby project which aims to solve organizational and other problems for authors, writers and story-tellers.",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg11,
  alt: "e-com",
  dark: true,
  primary: true,
  darkText: false,
  href: "https://ark-zephyr-mach1.web.app/",
};

export const HomeObjZephyr = {
  id: "codezephyr",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "code-zephyr",
  description: "Website i designed for my company, code-zephyr.com",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg11,
  alt: "e-com",
  dark: true,
  primary: true,
  darkText: false,
  href: "https://code-zephyr-de6e5.web.app/",
};

export const HomeObjAarkay = {
  id: "aarkay",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Featured Projects",
  headline: "ATCPL Business Website",
  description: "Built with Next JS and Tailwind CSS",
  buttonLabel: "Visit",
  imgStart: true,
  img: svg14,
  alt: "e-com",
  dark: false,
  primary: false,
  darkText: true,
  href: "https://atc-new-website.vercel.app/",
};
